var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBunkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 9,
    viewBox: "0 0 28 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5581 0.0042754C21.8618 -0.0581795 27.9158 0.528896 27.9991 4.07634C28.0907 8.04014 21.3455 8.15672 16.1326 8.03598C9.0336 7.87776 0.881148 5.65853 0.11087 3.68495C-1.00083 0.832843 6.398 0.095876 15.5581 0.0042754Z",
    fill: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1409 6.65851C12.8557 6.58356 9.18337 6.05478 6.06063 5.20539C2.43408 4.2186 1.20163 3.2568 1.0559 2.88623C0.951812 2.61976 0.997612 2.47403 1.1017 2.34079C1.37234 1.99105 2.33415 1.33319 5.76917 0.875185C8.15078 0.558747 11.3485 0.388036 15.5538 0.342236C15.6537 0.342236 15.7522 0.342236 15.8494 0.342236C19.4343 0.317254 22.0699 0.537928 23.9019 1.01675C26.6374 1.72874 26.9747 2.81545 26.9914 3.57324C27.008 4.19362 26.804 4.69326 26.3668 5.1013C24.7222 6.64186 20.0755 6.67516 18.5516 6.68349C17.8521 6.68766 17.086 6.67933 16.1409 6.65851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunkerIcon);
export default __webpack_public_path__ + "static/media/bunker-icon.705565e1dd588fee32a902938875dfe1.svg";
export { ForwardRef as ReactComponent };